// extracted by mini-css-extract-plugin
export default {"main":"styles_main__OQgLV","bg1":"styles_bg1__x5qH6","bg2":"styles_bg2__GPWmq","mainheading":"styles_mainheading__r8GE6","animation":"styles_animation__TrIMX"};